import React from 'react';
import { Runtime } from './components/Runtime';
import { setupStore } from './redux/store';
import { Provider as ReduxProvider } from 'react-redux';
import { uiInitialState as uiInitialState } from './redux/slices/ui';
import { userInitialState as userInitialState, } from './redux/slices/user';
import { configInitialState as configInitialState, } from './redux/slices/config';
import { ContextProvider } from './adapters';
import Video from './components/ui/Video';
import { DeliveryClientProvider, getKenticoConfigState, } from './kentico/deliveryClient';
import './styles/dreamcast.css';
import './styles/storybookStyles.css';
const WrappedRuntime = ({ content, kenticoConfig, state, externalAdapters, }) => {
    const { onUiStateChange, onUserStateChange } = externalAdapters;
    const storeAdapters = {
        onUiStateChange,
        onUserStateChange,
    };
    const initialState = {
        ui: { ...uiInitialState, cc: state.cc, muted: state.muted },
        user: { ...userInitialState, ...state.user },
        config: { ...configInitialState, ...state.config },
        modules: state.modules || [],
        plan: state.plan,
    };
    return (React.createElement(ReduxProvider, { store: setupStore(storeAdapters, initialState) },
        React.createElement(DeliveryClientProvider, { ...getKenticoConfigState(kenticoConfig) },
            React.createElement(ContextProvider, { value: {
                    ...externalAdapters,
                    videoComponent: Video,
                } },
                React.createElement("div", { className: "dreamcast-scope" },
                    React.createElement(Runtime, { ...content }))))));
};
export { WrappedRuntime as StorybookRuntime };
//# sourceMappingURL=index.js.map